
import React from "react";
import CrossIcon from "../../../../icons/cross.icon";
import PlusIcon from "../../../../icons/plus.icon";
import styles from "./send-notifications.component.module.scss";
import cn from "../../../../../Utils/class-names.utils";
import { Email } from "../mock-data";

interface SendNotificationsHandlers {
  handleAddEmail: () => void;
  handleRemoveEmail: (id: string) => void;
  handleEmailChange: (id: string, address: string) => void;
}

interface SendNotificationsComponentProps {
  emails: Email[];
  handleSendNotifications: SendNotificationsHandlers;
}

const SendNotificationsComponent = ({
  emails,
  handleSendNotifications
}: SendNotificationsComponentProps) => {

  return (
    <div className={styles.container}>
      <div className={styles.labelContainer}>
        <label className={styles.label}>
          Emails
        </label>
      </div>

      <div className={styles.emailsList}>
        {emails.map((email) => (
          <div
            key={email.id}
            className={styles.emailItem}
          >
            <div className={styles.emailInput}>
              <input
                type="email"
                value={email.address}
                onChange={(e) => handleSendNotifications.handleEmailChange(email.id, e.target.value)}
                className={styles.emailText}
                placeholder="Enter email address"
              />
            </div>

            <button
              type="button"
              onClick={() => handleSendNotifications.handleRemoveEmail(email.id)}
              aria-label={`Remove ${email.address}`}
              className={cn(styles.removeButton, 'my-button')}
            >
              <CrossIcon />
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={handleSendNotifications.handleAddEmail}
          className={cn(styles.addButton, 'my-button')}
          aria-label="Add email"
        >
          <div className={styles.addButtonIcon}>
            <PlusIcon />
          </div>

          <div className={styles.addButtonText}>
            <div className={styles.addButtonLabel}>
              Add
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default SendNotificationsComponent;